import pdfConfig from './helper';
import { convertBodyPdfFile } from '../exportHelper';

const HeaderTable = ({ t, columnsTable }) => columnsTable.map(val => t(val.exportLabel) || t(val.label));

const buildEnumMaps = (columnsTable, t) => {
  const enumMaps = {};
  columnsTable.forEach(col => {
    if (col.isRenderT) {
      const key = col.fieldOption || col.name;
      if (!enumMaps[key]) {
        try {
          const options = t(`selections:${key}`)();
          if (options) {
            const map = {};
            options.forEach(op => { map[op.value] = op.label; });
            enumMaps[key] = map;
          }
        } catch (e) { /* ignore */ }
      }
    }
  });
  return enumMaps;
};

const convertJson2Pdf = ({ data, t, title, fileName, columnsTable, fontSize, ...rest }) => {
  const Header = HeaderTable({ t, columnsTable });

  // Pre-cache enum translation lookups once (instead of per-row)
  const enumMaps = buildEnumMaps(columnsTable, t);

  // Use a for loop instead of data.map() to allow the engine to GC
  // intermediate row objects when pdfConfig processes data in chunks.
  const newListData = [];
  for (let i = 0; i < data.length; i++) {
    newListData.push(convertBodyPdfFile({ item: data[i], columnsTable, t, enumMaps }));
  }
  return pdfConfig({ data: newListData, Header, title, fileName, fontSize: fontSize || 5, cellPadding: 2, ...rest });
};

export default convertJson2Pdf;
